export const GET_AUTHORS = "GET_AUTHORS";
export const GET_AUTHOR_DETAILS = "GET_AUTHOR_DETAILS";
export const RESET_AUTHOR_DETAILS = "RESET_AUTHOR_DETAILS";
export const SET_AUTHOR_DETAIL_STATUS = "SET_AUTHOR_DETAIL_STATUS";
export const SET_AUTHOR_LIST_STATUS = "SET_AUTHOR_LIST_STATUS";

export enum authorType {
  author = "Author",
  reviewer = "Reviewer",
  both = "Both",
}

export const authorOptions = [
  { label: authorType.author, value: authorType.author },
  { label: authorType.reviewer, value: authorType.reviewer },
  { label: authorType.both, value: authorType.both },
];
